// Factory Socket.io con autenticazione dal token in store
import { io, type Socket } from 'socket.io-client'

const WS_URL = import.meta.env.VITE_WS_URL ?? 'http://localhost:3001'

let socketInstance: Socket | null = null

/** Restituisce (o crea) il client Socket.io autenticato */
export function getSocket(): Socket {
  if (socketInstance?.connected) return socketInstance

  const stored = localStorage.getItem('fc-auth')
  let token: string | undefined

  if (stored) {
    try {
      const { state } = JSON.parse(stored) as { state: { accessToken: string | null } }
      token = state.accessToken ?? undefined
    } catch {
      // Ignora
    }
  }

  socketInstance = io(WS_URL, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 5,
    autoConnect: true,
  })

  return socketInstance
}

/** Disconnette e distrugge il socket */
export function destroySocket(): void {
  if (socketInstance) {
    socketInstance.disconnect()
    socketInstance = null
  }
}

/** Tipi canali Socket.io FieldCore */
export const SOCKET_EVENTS = {
  GEOLOCATION_UPDATE: 'geolocation:update',
  TICKET_CREATED: 'ticket:created',
  TICKET_ASSIGNED: 'ticket:assigned',
  TICKET_STATUS_CHANGED: 'ticket:statusChanged',
  TICKET_ESCALATED: 'ticket:escalated',
  CHAT_MESSAGE: 'chat:message',
  NOTIFICATION_NEW: 'notification:new',
  TECHNICIAN_CHECKIN: 'technician:checkin',
  TECHNICIAN_CHECKOUT: 'technician:checkout',
  SLA_BREACH: 'sla:breach',
} as const

export type SocketEvent = (typeof SOCKET_EVENTS)[keyof typeof SOCKET_EVENTS]
